export const PAGE_SIZE = 8
export const MAX_PAGES = 10
